import {Button, ListGroup, Stack} from "react-bootstrap";
import {
    ItemLoading,
    MenuAdd,
    MenuBar,
    MenuClearSelectButton,
    MenuConfirmDeleteButton,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert,
    OurPagination2,
    PageTitle
} from "../../_components";
import React, {useRef} from "react";
import {useFetchJson, useGetJson, useLocalFilter2, useLongPress, useSelect, useTouch} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {useAlert, useAuth} from "../../../context";
import {Link, useSearchParams} from "react-router-dom";
import {useBrowserTitle} from "../../../hooks/useBrowserTitle";
import {ResponsiveContent} from "../../ResponsiveNavTabs";
import {centsToString} from "../admin/utilities/formatCurrency";

export function Discount() {
    useBrowserTitle("Discount");
    return <ResponsiveContent body={<DiscountBody/>}/>
}

function DiscountBody() {
    const {authToken} = useAuth()
    const {success} = useAlert()
    const [searchParams] = useSearchParams()
    const search = {query: searchParams.get("query")}

    const [dOrder, loadingDOrder, errorDOrder, clearErrorDOrder] = useGetJson(endpoints.discount.orderOptions(), authToken?.jwt)
    const orderOptions = dOrder?.data || []

    const [dCount, loadingDCount, errorDCount, clearErrorDCount, setDCount] = useGetJson(endpoints.discount.count(search), authToken?.jwt)
    const discountCount = dCount?.data || 0

    const searchL = {
        offset: Number(searchParams.get("index")) * Number(searchParams.get("size")),
        limit: Number(searchParams.get("size")),
        query: searchParams.get("query"),
        order_by: searchParams.get("by")
    }
    const [dList, loadingDList, errorAnList, clearErrorDList, setDList] = useGetJson(endpoints.discount.list(searchL), authToken?.jwt)
    const discountList = dList?.data || []

    const {exec: deleteItem, error: errDeleteItem, clearError: clearErrDeleteItem} = useFetchJson(authToken?.jwt, null, "POST")

    const loading = loadingDOrder || loadingDCount || loadingDList

    const filteredList = useLocalFilter2(discountList, ["code"])

    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(discountList)

    function handleOnItemsDelete() {
        Promise.all(selList.map(item => new Promise((resolve, reject) =>
            deleteItem(endpoints.discount.delete(item.id), null, () => resolve(item.id))).catch(err => console.warn(err))))
            .then(ids => {
                success(`${ids.length} announcement(s) deleted!`)
                setDList(prev => ({...prev, data: prev.data.filter(item => !ids.includes(item.id))}))
                setDCount(prev => ({...prev, data: prev.data - 1}))
                clearSelectItems()
            })
    }


    return <Stack>
        <OurClearAlert variant="danger" msg={errorDOrder} onClear={clearErrorDOrder}/>
        <OurClearAlert variant="danger" msg={errorDCount} onClear={clearErrorDCount}/>
        <OurClearAlert variant="danger" msg={errorAnList} onClear={clearErrorDList}/>
        <OurClearAlert variant="danger" msg={errDeleteItem} onClear={clearErrDeleteItem}/>

        <PageTitle title="Discount">{discountCount} discounts.</PageTitle>

        <MenuBar>
            <MenuAdd to={`/backend/discount/add`} icon="plus">Add</MenuAdd>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                {selList.length} {selList.length === 1 ? "row" : "rows"}
            </MenuClearSelectButton>
            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                <span>{selList.length} {selList.length === 1 ? "discount" : "discounts"}</span>
            </MenuConfirmDeleteButton>
        </MenuBar>


        <ItemLoading show={loading}/>


        {filteredList.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id}
                                item={item}
                                selected={isItemSelected(item.id)}
                                selectedCount={selList.length}
                                onSelect={toggleSelectItems}
                                to={`/backend/discount/${item.id}`}
                    />
                )}
            </ListGroup>
            :
            <span className="text-center">No discounts.</span>
        }

        <OurPagination2 loading={loading} itemCount={discountCount}/>
    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const {authToken} = useAuth()

    const [dUse, loadingDUse, errorDUse, clearErrorDUse] = useGetJson(endpoints.discount.use(item.code), authToken?.jwt)
    const discountUse = dUse?.data || 0

    const touch = useTouch()

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    return (
        <div ref={ref} className={`d-flex align-items-center gap-2 p-1 mb-2 rounded ${(selected ? "bg-light-subtle" : "hover-bg-light-subtle")}`}>
            {/*<Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "hover-bg-secondary-subtle"}`}>*/}
            <OurClearAlert variant="danger" msg={errorDUse} onClear={clearErrorDUse}/>

            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-megaphone fs-2"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.code}</span>
                        </Link>
                        <div className="text-secondary small">{centsToString(item.discount_in_cents)} €</div>
                    </Stack>
                </div>


                <div className="ms-auto">
                    <div className="d-flex align-items-center">
                        <div className="text-secondary">{`Uses: ${discountUse}`}</div>

                        {(!touch || selected || selectedCount > 0) &&
                            <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                                <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                            </Button>
                        }
                    </div>
                </div>
            </Stack>

        </div>
    )
}
